export const ENV_PRODUCTION = process.env.REACT_APP_NODE_ENV === "production";
export const API_URL_GRAPHQL = process.env.REACT_APP_API_URL_GRAPHQL;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const PRICER_URL = process.env.REACT_APP_PRICER_URL;